export default __webpack_public_path__ + "static/car_seat_icon_pink-8fb2f6fc1dbc17395214a32ca538616a.png";